import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';
import { Factory, DollarSign, Package, Truck, CreditCard, Zap, Settings, Hammer, Phone, Mail, CheckCircle, Droplets, Wind, Sparkles } from 'lucide-react';

const PorMayor = () => {
  return (
    <>
      <SEO 
        title="Venta al Por Mayor - Vapes y Perfumes Árabes | Distribuidores en Paraguay"
        description="ASMAR SHOP - Venta al por mayor de vapes, vaporizadores, pods, e-liquids y perfumes árabes en Paraguay. Precios especiales para revendedores, tiendas y distribuidores. ✓ Precios por volumen ✓ Stock permanente ✓ Entrega inmediata"
        keywords="vapes por mayor paraguay, perfumes árabes al por mayor, mayorista vapes, distribuidora vapes paraguay, venta por mayor vaporizadores, pods desechables por mayor, e-liquid mayorista, perfumes árabes mayorista, comprar vapes por mayor, revendedor vapes paraguay, bakhoor por mayor, oud por mayor"
        url="https://asmarshop.com/por-mayor"
        type="website"
      />
      
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
        {/* Hero Section */}
        <div style={{background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)'}} className="text-white py-16 px-4">
          <div className="max-w-6xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 flex items-center justify-center gap-3">
              <Factory className="w-10 h-10 md:w-12 md:h-12" />
              Venta al Por Mayor
            </h1>
            <p className="text-xl md:text-2xl mb-6 text-slate-300">
              Vapes y Perfumes Árabes — Distribuidores en Paraguay
            </p>
            <p className="text-lg text-slate-400 max-w-3xl mx-auto">
              Precios especiales para revendedores, tiendas, kioscos y distribuidores. 
              Compra en grandes volúmenes y maximiza tu ganancia.
            </p>
          </div>
        </div>

        {/* Benefits Section */}
        <div className="max-w-6xl mx-auto px-4 py-12">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            <div className="bg-white rounded-xl shadow-lg p-6 text-center">
              <div className="flex justify-center mb-3">
                <DollarSign className="w-10 h-10 text-green-600" />
              </div>
              <h3 className="font-bold text-lg mb-2">Precios Mayoristas</h3>
              <p className="text-gray-600 text-sm">Descuentos especiales por volumen de compra</p>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-6 text-center">
              <div className="flex justify-center mb-3">
                <Package className="w-10 h-10 text-blue-600" />
              </div>
              <h3 className="font-bold text-lg mb-2">Stock Permanente</h3>
              <p className="text-gray-600 text-sm">Inventario amplio siempre disponible</p>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-6 text-center">
              <div className="flex justify-center mb-3">
                <Truck className="w-10 h-10 text-orange-600" />
              </div>
              <h3 className="font-bold text-lg mb-2">Entregas Rápidas</h3>
              <p className="text-gray-600 text-sm">Envíos a todo Paraguay y Brasil</p>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-6 text-center">
              <div className="flex justify-center mb-3">
                <CreditCard className="w-10 h-10 text-purple-600" />
              </div>
              <h3 className="font-bold text-lg mb-2">Pago Flexible</h3>
              <p className="text-gray-600 text-sm">Condiciones especiales de pago</p>
            </div>
          </div>

          {/* Products Categories */}
          <div className="bg-white rounded-xl shadow-lg p-8 mb-12">
            <h2 className="text-3xl font-bold mb-6 text-center">Catálogo al Por Mayor</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div className="border-2 border-slate-200 rounded-lg p-6 hover:border-blue-500 transition-all">
                <h3 className="font-bold text-xl mb-3 text-slate-800 flex items-center gap-2">
                  <Wind className="w-5 h-5 text-slate-600" />
                  Pods Desechables
                </h3>
                <ul className="text-gray-600 space-y-2">
                  <li>• Pods de 600 a 10000 puffs</li>
                  <li>• Variedad de sabores</li>
                  <li>• Marcas reconocidas</li>
                  <li>• Packs surtidos</li>
                </ul>
              </div>

              <div className="border-2 border-slate-200 rounded-lg p-6 hover:border-blue-500 transition-all">
                <h3 className="font-bold text-xl mb-3 text-slate-800 flex items-center gap-2">
                  <Zap className="w-5 h-5 text-yellow-500" />
                  Vaporizadores y Mods
                </h3>
                <ul className="text-gray-600 space-y-2">
                  <li>• Kits de inicio</li>
                  <li>• Mods avanzados</li>
                  <li>• Pod systems recargables</li>
                  <li>• Baterías y cargadores</li>
                </ul>
              </div>

              <div className="border-2 border-slate-200 rounded-lg p-6 hover:border-blue-500 transition-all">
                <h3 className="font-bold text-xl mb-3 text-slate-800 flex items-center gap-2">
                  <Droplets className="w-5 h-5 text-blue-500" />
                  E-Liquids y Juice
                </h3>
                <ul className="text-gray-600 space-y-2">
                  <li>• Freebase y sales de nicotina</li>
                  <li>• Sabores frutales y dulces</li>
                  <li>• Botellas 30ml / 60ml / 120ml</li>
                  <li>• Packs por sabor o surtidos</li>
                </ul>
              </div>

              <div className="border-2 border-slate-200 rounded-lg p-6 hover:border-blue-500 transition-all">
                <h3 className="font-bold text-xl mb-3 text-slate-800 flex items-center gap-2">
                  <Sparkles className="w-5 h-5 text-amber-500" />
                  Perfumes Árabes
                </h3>
                <ul className="text-gray-600 space-y-2">
                  <li>• Perfumes Oud importados</li>
                  <li>• Attar concentrados</li>
                  <li>• Musk árabe</li>
                  <li>• Fragancias orientales</li>
                </ul>
              </div>

              <div className="border-2 border-slate-200 rounded-lg p-6 hover:border-blue-500 transition-all">
                <h3 className="font-bold text-xl mb-3 text-slate-800 flex items-center gap-2">
                  <Settings className="w-5 h-5 text-slate-600" />
                  Accesorios Vape
                </h3>
                <ul className="text-gray-600 space-y-2">
                  <li>• Coils y resistencias</li>
                  <li>• Algodón y alambre</li>
                  <li>• Tanques y drip tips</li>
                  <li>• Herramientas de armado</li>
                </ul>
              </div>

              <div className="border-2 border-slate-200 rounded-lg p-6 hover:border-blue-500 transition-all">
                <h3 className="font-bold text-xl mb-3 text-slate-800 flex items-center gap-2">
                  <Hammer className="w-5 h-5 text-slate-600" />
                  Bakhoor e Incienso
                </h3>
                <ul className="text-gray-600 space-y-2">
                  <li>• Chips de oud</li>
                  <li>• Bakhoor árabe</li>
                  <li>• Quemadores e incensarios</li>
                  <li>• Sets de regalo</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Why Choose Us */}
          <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-xl shadow-lg p-8 mb-12 text-white">
            <h2 className="text-3xl font-bold mb-6 text-center">¿Por qué elegirnos?</h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-bold text-xl mb-2">Experiencia Comprobada</h3>
                  <p className="text-blue-100">Importadores directos de vapes y perfumes árabes de calidad en Paraguay</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-bold text-xl mb-2">Productos Originales</h3>
                  <p className="text-blue-100">Trabajamos solo con marcas reconocidas y productos 100% auténticos</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-bold text-xl mb-2">Asesoramiento Personalizado</h3>
                  <p className="text-blue-100">Te ayudamos a armar el mejor surtido para tu negocio</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-bold text-xl mb-2">Logística Eficiente</h3>
                  <p className="text-blue-100">Entregas rápidas y seguras a todo Paraguay y Brasil</p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-white rounded-xl shadow-lg p-8 text-center">
            <h2 className="text-3xl font-bold mb-4">¿Listo para comprar al por mayor?</h2>
            <p className="text-gray-600 mb-6 text-lg">
              Contactanos hoy y obtén una cotización personalizada para tu negocio
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/products" 
                className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 px-8 rounded-lg transition-all shadow-lg"
              >
                Ver Catálogo Completo
              </Link>
              <Link 
                to="/contact" 
                className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-8 rounded-lg transition-all shadow-lg"
              >
                Solicitar Cotización
              </Link>
            </div>
            
            <div className="mt-8 pt-8 border-t border-gray-200">
              <p className="text-gray-700 font-semibold mb-2 flex items-center justify-center gap-2">
                <Phone className="w-5 h-5" />
                Contacto Directo
              </p>
              <p className="text-gray-600">WhatsApp: +595 999 999 999</p>
              <p className="text-gray-600">Email: mayoristas@asmarshop.com</p>
            </div>
          </div>

          {/* SEO Content */}
          <div className="mt-12 prose prose-slate max-w-none bg-white rounded-xl shadow-lg p-8">
            <h2 className="text-2xl font-bold mb-4">Distribuidores Mayoristas de Vapes y Perfumes Árabes en Paraguay</h2>
            <p className="text-gray-700 mb-4">
              <strong>ASMAR SHOP</strong> es tu distribuidor mayorista de confianza en Paraguay para vapes, 
              vaporizadores, pods desechables, e-liquids y perfumes árabes importados. Ofrecemos los mejores precios 
              del mercado para revendedores, tiendas, kioscos y distribuidores en todo el país.
            </p>
            
            <h3 className="text-xl font-bold mb-3">Vapes y E-Liquids al Por Mayor</h3>
            <p className="text-gray-700 mb-4">
              Contamos con un amplio catálogo de pods desechables, vaporizadores recargables, mods avanzados, 
              e-liquids freebase y sales de nicotina de las mejores marcas del mercado. Nuestros precios 
              mayoristas están diseñados para que tu negocio sea rentable desde la primera compra.
            </p>

            <h3 className="text-xl font-bold mb-3">Perfumes Árabes Importados al Por Mayor</h3>
            <p className="text-gray-700 mb-4">
              Importamos directamente perfumes oud, attar concentrados, bakhoor, musk árabe y fragancias 
              orientales de la más alta calidad. Ideales para perfumerías, tiendas de regalos y revendedores 
              que buscan ofrecer productos únicos y exclusivos a sus clientes.
            </p>

            <h3 className="text-xl font-bold mb-3">Envíos a Todo Paraguay y Brasil</h3>
            <p className="text-gray-700">
              Realizamos envíos a todo Paraguay y Brasil. Nuestro sistema logístico 
              garantiza entregas rápidas y seguras. Consultá por condiciones especiales de envío 
              para pedidos mayoristas y descuentos por volumen.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PorMayor;
